import styled from "styled-components";

export const DrawerOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  overflow: hidden;
`;

export const DrawerContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 320px;
  height: 100vh;
  background: #f8f8f8;
  box-shadow: 4px 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 0 12px 12px 0;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease-in-out;

  @media (max-width: 768px) {
    width: 100%;
    border-radius: 0;
  }
`;

export const DrawerHeader = styled.div`
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    color: #333;
    font-weight: bold;
    font-size: 20px;
  }

  button {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #333;
  }
`;

export const DrawerContent = styled.div`
  padding: 0 20px 20px 20px;
  overflow-y: auto;
  flex: 1;

  /* Estilizando scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 4px;
  }

  button {
    margin-bottom: 15px;
    text-align: left;
    border: none;
    background: none;
    padding: 0;
    width: 100%;

    &:hover {
      opacity: 0.9;
    }
  }
`;

export const HomeCard = styled.div`
  display: flex;
  align-items: center;
  padding: 15px;
  background: #f1f1f1;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  transition: background 0.3s, transform 0.3s;

  &:hover {
    background: #e0e0e0;
    transform: translateX(5px);
  }

  img {
    height: 30px;
    width: 30px;
    margin-right: 15px;
  }

  span {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
